const LinkedDropdowns = ({
  selMM,
  months,
  mmdata,
  setSelMM,
  setMonths,
  selMonth,
  setSelmonth,
  getCompData,
  setComData,
  setOrigComData,
}) => {
  const handleMMChange = (event) => {
    const user = event.target.value;
    setSelMM(user);
    setSelmonth("");
    setComData(new Map());
    setOrigComData(new Map());

    if (mmdata.has(user)) {
      setMonths(mmdata.get(user).months);
    } else {
      setMonths(new Map());
    }
  };

  const handleMonthChange = (event) => {
    const month = event.target.value;
    setSelmonth(month);
    getCompData(selMM, months.get(month));
  };

  return (
    <div className="flex gap-4">
      <select
        id="user-select"
        value={selMM}
        onChange={handleMMChange}
        className="sm:text-sm rounded-md"
      >
        <option value="">--Market Maker--</option>
        {[...mmdata.keys()].map((key) => (
          <option key={key} value={key}>
            {key}
          </option>
        ))}
      </select>

      <select
        id="month-select"
        disabled={!selMM}
        onChange={handleMonthChange}
        value={selMonth}
        className="sm:text-sm rounded-md"
      >
        <option value="">--Mes de análisis--</option>
        {[...months?.keys()].map((month) => (
          <option key={month} value={month}>
            {month}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LinkedDropdowns;
